import { Moon, Clock, AlertTriangle, FileWarning, Users, Target, CheckCircle } from 'lucide-react';

const WhatKeepsYouUp = () => {
  const fears = [
    {
      fear: 'Funding expires before award',
      icon: Clock,
      solution: 'Real-time pipeline visibility with funding lapse risk alerts'
    },
    {
      fear: 'Protests derailing programs',
      icon: AlertTriangle,
      solution: 'Defensible documentation auto-generated throughout'
    },
    {
      fear: 'IG audits finding gaps',
      icon: FileWarning,
      solution: 'Complete audit trail from day one. Nothing falls through cracks'
    },
    {
      fear: 'Staff burnout and turnover',
      icon: Users,
      solution: '70-85% grunt work automated. Your team does real work'
    },
    {
      fear: 'Mission delays from procurement',
      icon: Target,
      solution: '4-8 months → 1-3 weeks. Programs don\'t wait.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/20 border border-purple-500/30 text-purple-300 font-medium rounded-full mb-6">
            <Moon className="w-5 h-5" />
            <span>What Keeps Acquisition Leaders Up at Night</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            We Know Your{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-500">Nightmares</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            And we built AcuSightPro to make them go away.
          </p>
        </div>

        <div className="space-y-4">
          {fears.map((item, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-purple-500/50 transition-all group"
            >
              <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
                <div className="flex items-center gap-4 md:w-1/3">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-amber-500/20">
                    <item.icon className="w-6 h-6 text-amber-400" />
                  </div>
                  <div className="text-white font-semibold text-lg">"{item.fear}"</div>
                </div>
                <div className="hidden md:block text-gray-600">→</div>
                <div className="flex items-center gap-3 md:flex-1 bg-emerald-500/10 rounded-lg px-4 py-3">
                  <CheckCircle className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                  <span className="text-emerald-300">{item.solution}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">
            Stop managing crises. Start{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400">preventing them</span>.
          </h3>
          <a
            href="/contact"
            className="inline-flex px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-full hover:shadow-lg hover:shadow-purple-500/30 transition-all hover:-translate-y-0.5 mt-4"
          >
            See How It Works
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhatKeepsYouUp;
